import React, { useState, useRef, useEffect } from 'react';
import { DateRangePicker } from './DateRangePicker';

interface DateFilterProps {
  onFilterChange: (filter: string, startDate?: Date, endDate?: Date) => void;
  filterOptions: string[];
  title: string;
  style?: string;
  width?: string;
  defaultValue?: string;
}

const Dropdown: React.FC<DateFilterProps> = ({
  onFilterChange,
  filterOptions,
  title,
  style,
  width,
  defaultValue,
}) => {
  const [filter, setFilter] = useState(defaultValue ?? filterOptions[0] ?? 'All');

  const [open, setOpen] = useState(false);

  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handler = (e: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target as Node)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  const handleFilterChange = (e: { target: { value: string } }) => {
    const selected = e.target.value;
    setFilter(selected);

    if (selected !== 'CustomRange') {
      onFilterChange(selected);
    }
  };
  useEffect(() => {
    if (defaultValue !== undefined && defaultValue !== filter) {
      setFilter(defaultValue);
    }
  }, [defaultValue]);

  return (
    <div className="flex flex-col items-end gap-2">
      {/* Custom Dropdown */}
      <div ref={dropdownRef} className={`relative  ${width ? width : 'w-52'}`}>
        <div
          className={`bg-white border-green px-3 py-2 rounded-lg w-full flex items-center gap-2 ${style}`}
        >
          <span className="text-xs whitespace-nowrap text-[#A4A4A4] border-r border-green3 px-1 font-medium">
            {title}
          </span>
          <button onClick={() => setOpen(!open)} className="w-full flex-between">
            <span className="text-black text-xs">{filter}</span>
            <svg
              className={`w-4 h-4 transition-transform ${open ? 'rotate-180' : 'rotate-0'}`}
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              viewBox="0 0 24 24"
            >
              <path d="M19 9l-7 7-7-7" />
            </svg>
          </button>
        </div>

        {open && (
          <ul className="absolute z-20 mt-1 w-full bg-white border-green rounded-lg shadow-lg max-h-60 overflow-y-auto">
            {filterOptions.map((opt) => (
              <li
                key={opt}
                onClick={() => {
                  handleFilterChange({ target: { value: opt } });
                  setOpen(false);
                }}
                className={`cursor-pointer text-black text-[11px] px-3 py-2 hover:bg-green/20 border-b-0 border-green ${
                  filter === opt ? 'bg-green/20 font-semibold' : ''
                }`}
              >
                {opt}
              </li>
            ))}
          </ul>
        )}
      </div>
      {filter === 'CustomRange' && (
        <DateRangePicker
          // value={selectedRange}
          // onChange={(newRange) => setSelectedRange(newRange)}
          // onApply={() => {
          //   setAppliedRange(selectedRange);
          //   setCurrentPage(1);
          // }}
          className="w-fit text-black"
        />
      )}
    </div>
  );
};

export default Dropdown;
